import { LOCATION_CHANGE } from 'connected-react-router'
import { take } from 'lib/arrayUtils'

const initialState: App.RouteHistoryState = {
  recentHistory: [],
  previous: '',
  previousSearch: '',
  search: '',
  current: '',
}

export default function routeHistoryReducer(state = initialState, action): App.RouteHistoryState {
  switch (action.type) {
    case LOCATION_CHANGE:
      if (action.payload.location.pathname === state.current) {
        return state
      }

      return {
        recentHistory: take([
          state.current + state.search ? `?${state.search}` : '',
          ...state.previous,
        ], 5),
        previous: state.previous,
        previousSearch: state.search,
        search: action.payload.location.search,
        current: action.payload.location.pathname,
      }
    default:
      return state
  }
}
